import { transitions } from "@ecco/ui/tokens";

export const wrapperStyle = {
    whiteSpace: "pre-line",
    maxWidth: "container.sx",
    gap: 2,
    flexDirection: "column",
    alignItems: "start",
};

export const buttonStyle = {
    h: ["fit-content"],
    p: 0,
    px: 0,
};

export const iconStyle = (isOpen: boolean) => ({
    transition: `${transitions.property.common} ${transitions.duration.fast}`,
    transform: isOpen ? "rotate(180deg)" : "",
});
